import { Stack, Typography } from '@mui/material';

interface HomeHeaderProps {
  userHaveNotes: boolean | null;
}

const HomeHeader = ({ userHaveNotes }: HomeHeaderProps) => {
  return (
    <Stack
      maxWidth={1620}
      width="100%"
      height={64}
      alignItems={'center'}
      justifyContent={'space-between'}
      flexDirection={'row'}
    >
      <Stack spacing={1} alignItems={'flex-start'}>
        <Typography variant="h5" fontWeight="700">
          {userHaveNotes === true ? 'Most Recent' : 'Home'}
        </Typography>
        <Typography variant="body1">
          {userHaveNotes === true
            ? 'View your most recently added or updated items here.'
            : 'Find an overview of your account and main features here.'}
        </Typography>
      </Stack>
    </Stack>
  );
};

export default HomeHeader;
